// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"0adc50fb","563":"ab258c6b"}[chunkId] + ".chunk.js";
};